module.exports = __webpack_public_path__ + "img/img4.e3d85899.png";